import React, { useEffect, useState } from "react";
import BookItem from "./BookItem";
import { useDispatch, useSelector } from "react-redux";
import fetchBooks from "../redux/books/thunk/fetchbooks";
import { statusChanged } from "../redux/filters/actions";

const BookListSection = () => {
  const books = useSelector((state) => state?.bookStore?.books);
  const filters = useSelector((state) => state?.filters);
  const dispatch = useDispatch();
  const [activeFilterValue, setActiveFilterValue] = useState("all");

  // Functions
  const changeActiveFilterValueFunc = (value) => {
    setActiveFilterValue(value);
    dispatch(statusChanged(value));
  };

  // filter by status ...
  const filterByStatus = (book) => {
    const { status } = filters;

    switch (status) {
      case "featured":
        return book.featured;
      default:
        return true;
    }
  };

  // filter by searchText ...
  const filterBysearch = (book) => {
    const { search } = filters || {};
    let searchText = search.toLowerCase();
    let bookName = book.name.toLowerCase();
    return bookName.includes(searchText);
  };

  // Fetching books data ...
  useEffect(() => {
    dispatch(fetchBooks);
  }, [dispatch]);

  return (
    <div>
      {/* filter options */}
      <div className="flex items-center justify-between mb-12">
        <h4 className="mt-2 text-xl font-bold">Book List</h4>

        <div className="flex items-center space-x-4">
          <button
            className={`filter-btn ${
              activeFilterValue === "all" && "active-filter"
            }`}
            id="lws-filterAll"
            onClick={() => changeActiveFilterValueFunc("all")}
          >
            All
          </button>
          <button
            className={`filter-btn ${
              activeFilterValue === "featured" && "active-filter"
            }`}
            id="lws-filterFeatured"
            onClick={() => changeActiveFilterValueFunc("featured")}
          >
            Featured
          </button>
        </div>
      </div>

      <div className="lws-bookContainer">
        {books.length ? (
          books
            .filter(filterByStatus)
            .filter(filterBysearch)
            .map((book) => <BookItem key={book?.id} book={book} />)
        ) : (
          <p className="text-red-500">No book Found! But you can add</p>
        )}
      </div>
    </div>
  );
};

export default BookListSection;
